import React from 'react';
import * as FadeIn from './FadeIn';
import Logo from ".././img/About_illust.png";
import Logo2 from ".././img/Home Link_logo.jpg";
import Logo3 from ".././img/News_thumbnail.PNG";
import Logo4 from ".././img/Home_thmb.jpg";
import Logo5 from ".././img/Home_thmb_Goto.png";
import Logo6 from ".././img/Home_thmb_Sanada.png";
import Logo7 from ".././img/Home_thmb_Tachibana.png";
import Logo8 from ".././img/Home_thmb_Nagami.png";
import Logo9 from ".././img/Home_News_thmb.png";
import Logo10 from ".././img/Members_Goto.png";
import Logo11 from ".././img/Members_Sanada.png";
import Logo12 from ".././img/Members_Tachibana.png";
import Logo13 from ".././img/Members_Nagami.png";
import Logo14 from ".././img/yajirusi_left.png";
import Logo15 from ".././img/yajirusi_right.png";
import Logo16 from ".././img/thum_intro_Goto.PNG";
import Logo17 from ".././img/thum_intro_Nagami.PNG";
import Logo18 from ".././img/thumnail_youtube_1.png";
import Logo19 from ".././img/thumnail_youtube_2.jpg";
import Logo20 from ".././img/thumnail_youtube_3.png";
import Logo21 from ".././img/thumnail_youtube_4.jpg";
import Logo22 from ".././img/thumnail_youtube_5.jpg";
import Logo23 from ".././img/thumnail_youtube_6.png";



class Main extends React.Component{
  constructor(props) {
    super(props);
    this.state = {
      isAbout: false,
      isNews: false,
      isMembers: false,
      isContact: false,
      isHome: true,
      isGoto: false,
      isSanada: false,
      isTachibana: false,
      isNagami: false,
      isLog: false,
  };
}

handleClickAbout(){
  this.setState({isAbout: true});
  this.setState({isNews: false});
  this.setState({isMembers: false});
  this.setState({isContact: false});
  this.setState({isHome: false});
  this.setState({isGoto: false})
  this.setState({isSanada: false})
  this.setState({isTachibana: false})
  this.setState({isNagami: false})
  this.setState({isLog: false})
}

handleClickNews(){
  this.setState({isAbout: false});
  this.setState({isNews: true});
  this.setState({isMembers: false});
  this.setState({isContact: false});
  this.setState({isHome: false});
  this.setState({isGoto: false})
  this.setState({isSanada: false})
  this.setState({isTachibana: false})
  this.setState({isNagami: false})
  this.setState({isLog: false})
}

handleClickMembers(){
  this.setState({isAbout: false});
  this.setState({isNews: false});
  this.setState({isMembers: true});
  this.setState({isContact: false});
  this.setState({isHome: false});
  this.setState({isGoto: true})
  this.setState({isSanada: false})
  this.setState({isTachibana: false})
  this.setState({isNagami: false})
  this.setState({isLog: false})
}

handleClickGoto(){
  this.setState({isAbout: false});
  this.setState({isNews: false});
  this.setState({isMembers: true});
  this.setState({isContact: false});
  this.setState({isHome: false});
  this.setState({isGoto: true})
  this.setState({isSanada: false})
  this.setState({isTachibana: false})
  this.setState({isNagami: false})
  this.setState({isLog: false})
}

handleClickSanada(){
  this.setState({isAbout: false});
  this.setState({isNews: false});
  this.setState({isMembers: true});
  this.setState({isContact: false});
  this.setState({isHome: false});
  this.setState({isGoto: false})
  this.setState({isSanada: true})
  this.setState({isTachibana: false})
  this.setState({isNagami: false})
  this.setState({isLog: false})
}

handleClickTachibana(){
  this.setState({isAbout: false});
  this.setState({isNews: false});
  this.setState({isMembers: true});
  this.setState({isContact: false});
  this.setState({isHome: false});
  this.setState({isGoto: false})
  this.setState({isSanada: false})
  this.setState({isTachibana: true})
  this.setState({isNagami: false})
  this.setState({isLog: false})
}

handleClickNagami(){
  this.setState({isAbout: false});
  this.setState({isNews: false});
  this.setState({isMembers: true});
  this.setState({isContact: false});
  this.setState({isHome: false});
  this.setState({isGoto: false})
  this.setState({isSanada: false})
  this.setState({isTachibana: false})
  this.setState({isNagami: true})
  this.setState({isLog: false})
}

handleClickContact(){
  this.setState({isAbout: false});
  this.setState({isNews: false});
  this.setState({isMembers: false});
  this.setState({isContact: true});
  this.setState({isHome: false});
  this.setState({isGoto: false})
  this.setState({isSanada: false})
  this.setState({isTachibana: false})
  this.setState({isNagami: false})
  this.setState({isLog: false})
}

handleClickHome(){
  this.setState({isAbout: false});
  this.setState({isNews: false});
  this.setState({isMembers: false});
  this.setState({isContact: false});
  this.setState({isHome: true});
  this.setState({isGoto: false})
  this.setState({isSanada: false})
  this.setState({isTachibana: false})
  this.setState({isNagami: false})
  this.setState({isLog: false})
}

handleClickLog(){
  this.setState({isAbout: false});
  this.setState({isNews: false});
  this.setState({isMembers: false});
  this.setState({isContact: false});
  this.setState({isHome: false});
  this.setState({isGoto: false})
  this.setState({isSanada: false})
  this.setState({isTachibana: false})
  this.setState({isNagami: false})
  this.setState({isLog: true})
}

render() {
    let Contents;
    let Char;
   if(this.state.isAbout){
      Contents=(
      <div className="Contens_About">
<FadeIn.Left>
        <h1 className="Contents_text">About</h1>
</FadeIn.Left>
        <img className="logo" src={Logo} alt="Logo" />
        <h4>活動記録</h4>
        <h3>2021年/09月/30日 活動準備開始</h3>
        <h3>2022年/03月/01日 デモンストレーション期間終了</h3>
      </div>
   );
  }

  if(this.state.isNews){
    Contents=(
<div className="Contents_News">
<FadeIn.Right>
 <h1 className="Contents_text">News</h1>
</FadeIn.Right>
 <h1 className="news_text">活動準備開始🎨</h1>
 <h4 className="article">4人のメンバーによって構成されるYouTuberグループ"かおすぱれっと"が本日10月1日より結成に向けた準備を開始しました。3月上旬ごろに正式な結成発表することを目標に様々な情報を発信していきます。</h4>
 <h5 className="date">2021/10/01</h5>
 <h1 className="news_text">公式twitter開設🎨</h1>
 <h4 className="article">"かおすぱれっと"の公式Twitterが開設されました。メンバーの紹介や今後のスケジュール、準備進行の進捗具合などの情報をお届けします。是非、公式Twitter・メンバーそれぞれのTwitterのフォローをよろしくお願いします。</h4>
 <h5 className="date">2021/10/01</h5>
</div>
   );
  }

if(this.state.isMembers){
    Contents=(
 <div className="Contents_Members">
<FadeIn.Down>
<h1 className="Contents_text">Members</h1>
</FadeIn.Down>
   <tr className="char_logo_top">
    <td className="Home_Goto"><img onClick={()=>this.handleClickGoto()} className="logo5" src={Logo5} alt="Logo"/></td>
    <td className="Home_Sanada"><img onClick={()=>this.handleClickSanada()} className="logo6" src={Logo6} alt="Logo"/></td>
    <td className="Home_Tachibana"><img onClick={()=>this.handleClickTachibana()} className="logo7" src={Logo7} alt="Logo"/></td>
    <td className="Home_Nagami"><img onClick={()=>this.handleClickNagami()} className="logo8" src={Logo8} alt="Logo" /></td>
   </tr>
 </div>
 )
}

if(this.state.isGoto){
  Char=(
<div className="members_Changes">
 <div className="member_prof">
  <h2 className="Prof">Profile</h2>
  <h2 className="prof_name">五戸アキ　(エンジニア)</h2>
  <h3 className="prof_text">かおすぱれっとの活動の広告塔。公式サイトの運営などをしながらチーム全体を支えるエンジニアとして信頼されている。好きな物はペン回しと昼寝。朝が弱くて二度寝常習犯。</h3>
 </div>
   <img onClick={()=>this.handleClickNagami()} className="yajirusi" src={Logo14} alt="Logo" />
   <img className="member_choose" src={Logo10} alt="Logo" />
   <img onClick={()=>this.handleClickSanada()} className="yajirusi" src={Logo15} alt="Logo" />
</div>
 )
}

if(this.state.isSanada){
  Char=(
<div className="members_Changes">
 <div className="member_prof">
  <h2 className="Prof">Profile</h2>
  <h2 className="prof_name">真田幸成 &nbsp; &nbsp; &nbsp; (絵師)</h2>
  <h3 className="prof_text">かおすぱれっとの大黒柱。一人でいるときはクールな印象を受けるが、メンバーの4人が揃ってスイッチが入ればこれでもかと騒ぎ合う男。好きな物はコーラとラノベ。転生前に夢だったイラストレーターになるべく日々奮闘している。</h3>
 </div>
   <img onClick={()=>this.handleClickGoto()} className="yajirusi" src={Logo14} alt="Logo" />
   <img className="member_choose" src={Logo11} alt="Logo" />
   <img onClick={()=>this.handleClickTachibana()} className="yajirusi" src={Logo15} alt="Logo" />
</div>
 )
}

if(this.state.isTachibana){
  Char=(
<div className="members_Changes">
 <div className="member_prof">
 <h2 className="Prof">Profile</h2>
 <h2 className="prof_name">立花ケヱタ &nbsp; (歌い手)</h2>
 <h3 className="prof_text">かおすぱれっとのリーダー。他のメンバーをまとめる役を担うが、普段は声がでかくて騒がしい変態。歌とラノベと可愛い女の子が好き。最近キムチにハマっている。</h3>
 </div>
   <img onClick={()=>this.handleClickSanada()} className="yajirusi" src={Logo14} alt="Logo" />
   <img className="member_choose" src={Logo12} alt="Logo" />
   <img onClick={()=>this.handleClickNagami()} className="yajirusi" src={Logo15} alt="Logo" />
</div>
 )
}

if(this.state.isNagami){
  Char=(
<div className="members_Changes">
 <div className="member_prof">
  <h2 className="Prof">Profile</h2>
  <h2 className="prof_name">永見こうき &nbsp; (配信者)</h2>
  <h3 className="prof_text">かおすぱれっとで一番のお調子者。4人の中では最も意欲的に配信活動などをしており、活発に動いている。好きな物はFPSゲームとアニメ。日本の文化をどんどん世界に広めたいと思っている。</h3>
 </div>
   <img onClick={()=>this.handleClickTachibana()} className="yajirusi" src={Logo14} alt="Logo" />
   <img className="member_choose" src={Logo13} alt="Logo" />
   <img onClick={()=>this.handleClickGoto()} className="yajirusi" src={Logo15} alt="Logo" />
</div>
 )
}

  if(this.state.isContact){
      Contents=(
    <div className="Contents_Contact">
<FadeIn.Up>
     <h1 className="Contents_text">Contact</h1>
</FadeIn.Up>
     <h2 className="Contact_adress">ChaosPalette@gmail.com</h2>
     <h3 className="Contact_text">お手数ですかメールアドレスはこちらですので、こちらに送っていただけると幸いです。</h3>
     <h3 className="Contact_text">こちらのサイトで使われているかおすぱれっとのロゴはメンバーの手によって作られたものです。</h3>
    </div>
      )
    }

if(this.state.isHome){
  Contents=(
<div className="Contents_Home">
<FadeIn.Up>
  <h1 className="Contents_text">Home</h1>
</FadeIn.Up>
  <img className="Home_thmb" src={Logo4} alt="Logo" />
  <h1 className="Home_contents">About</h1>
<FadeIn.Up>
 <div className="Home_about">
  <h2 className="Home_about_text2">"かおすぱれっと"とは</h2>
  <h3 className="Home_about_text3">4人のメンバーによって構成されるYouTuberグループ"かおすぱれっと"</h3>
  <h2 className="Home_about_text2">歴史</h2>
  <h3 className="Home_about_text3">・2021年/09月/30日 活動準備開始</h3>
  <h3 className="Home_about_text3">・2022年/03月/01日 デモンストレーション期間終了</h3>
 </div>
   <h3 onClick={()=>this.handleClickAbout()} className="See_more">もっと見る</h3>
</FadeIn.Up>
 <h1 className="Home_contents">News</h1>
 <FadeIn.Up>
 <div  className="Home_News">
 <h1 className="news_text">活動準備開始🎨</h1>
 <h4 className="article">4人のメンバーによって構成されるYouTuberグループ"かおすぱれっと"が本日10月1日より結成に向けた準備を開始しました。3月上旬ごろに正式な結成発表することを目標に様々な情報を発信していきます。</h4>
 <h5 className="date">2021/10/01</h5>
 </div>
 <h3 onClick={()=>this.handleClickNews()}  className="See_more">もっと見る</h3>
 </FadeIn.Up>
 <h1 className="Home_contents">Members</h1>
 <FadeIn.Up>
 <table className="Home_members">
  <tr>
   <td className="Home_Goto"><img onClick={()=>this.handleClickGoto()} className="logo5" src={Logo5} alt="Logo"/></td>
   <td className="Home_Sanada"><img onClick={()=>this.handleClickSanada()} className="logo6" src={Logo6} alt="Logo"/></td>
   <td className="Home_Tachibana"><img onClick={()=>this.handleClickTachibana()} className="logo7" src={Logo7} alt="Logo"/></td>
   <td className="Home_Nagami"><img onClick={()=>this.handleClickNagami()} className="logo8" src={Logo8} alt="Logo" /></td>
  </tr>
  <td className="Home_members_text">五戸アキ</td>
  <td className="Home_members_text">真田幸成</td>
  <td className="Home_members_text">立花ケヱタ</td>
  <td className="Home_members_text">永見こうき</td>
 </table>
   <h3 onClick={()=>this.handleClickMembers()}  className="See_more_2">もっと見る</h3>
  </FadeIn.Up>
<FadeIn.Up>
 <h1 className="Home_contents_Contact">Contact</h1>
  </FadeIn.Up>
<FadeIn.Up>
 <div className="Home_Contact" >
 <h2>要望・コラボ依頼・応援メッセージ等ありましたらこちらのフォームへ</h2>
 </div>
  <h3 onClick={()=>this.handleClickContact()}  className="See_more">もっと見る</h3>
</FadeIn.Up>
  <h1 className="Home_contents">Log</h1>
<FadeIn.Up>
  <div  className="Home_Log">
   <img className="Home_Log_image" src={Logo23} alt="Logo" />
  </div>
  <h3 onClick={()=>this.handleClickLog()}  className="See_more">もっと見る</h3>
</FadeIn.Up>
</div>
  )
}

if(this.state.isLog){
  Contents=(
<div className="Contents_Log">
<FadeIn.Left>
<h1 className="Contents_text">Log</h1>
</FadeIn.Left>
<FadeIn.Up>
<div className="Log_set">
<a href="https://www.youtube.com/watch?v=l5_X36pyEwM"><img className="Log_thumbnail" src={Logo23} alt="Logo"/></a>
<h3 className="Log_text"><a href="https://www.youtube.com/watch?v=l5_X36pyEwM">【minecraft】世界九位のアルケミスト五戸に研究室を作ってあげるぞ！！！！【転クラ</a> <p>編集:立花ケヱタ</p></h3>
</div>
<h4 className="Log_article">転クラシリーズ2本目の動画となります。実は間の録画データが飛んでしまっていて、内容が前回から少し進んだものとなっています。その間にあった面白い話だとかYggdrasillの歴史については毎週行う配信にて話していくのでそちらのチェックもぜひともよろしくお願いします。</h4>
</FadeIn.Up>
<FadeIn.Up>
<div className="Log_set">
<a href="https://www.youtube.com/watch?v=DM2nb1C-qhU"><img className="Log_thumbnail" src={Logo22} alt="Logo"/></a>
<h3 className="Log_text"><a href="https://www.youtube.com/watch?v=DM2nb1C-qhU">【VALORANT】コントローラー専がデュエピック？！苦手ピックでチームを救え！！【かおすぱれっと】</a> <p>編集:永見こうき</p></h3>
</div>
<h4 className="Log_article">ヴァロラント四本目の動画です!!</h4>
</FadeIn.Up>
<FadeIn.Up>
<div className="Log_set">
<a href="https://www.youtube.com/watch?v=cNjzyUiHx2g"><img className="Log_thumbnail" src={Logo21} alt="Logo"/></a>
<h3 className="Log_text"><a href="https://www.youtube.com/watch?v=cNjzyUiHx2g">【VALORANT】使用回数ほぼ０回のレイズ使ったらすごいことに？！？！【かおすぱれっと】</a> <p>編集:永見こうき</p></h3>
</div>
<h4 className="Log_article">ヴァロラント三本目の動画です!!</h4>
</FadeIn.Up>
<FadeIn.Up>
<div className="Log_set">
<a href="https://www.youtube.com/watch?v=sYVT9zrfmNE&t=2s"><img className="Log_thumbnail" src={Logo20} alt="Logo"/></a>
<h3 className="Log_text"><a href="https://www.youtube.com/watch?v=sYVT9zrfmNE&t=2s">【VALROANT】ヴァロラント初心者のメンバーをキャリーすることができるか？！【かおすぱれっと】</a> <p>編集:永見こうき</p></h3>
</div>
<h4 className="Log_article">ヴァロラント二本目の動画です！編集担当の永見です！！今回は初めてのかおぱれフルパでのヴァロです！！</h4>
</FadeIn.Up>
<FadeIn.Up>
<div className="Log_set">
<a href="https://www.youtube.com/watch?v=cNjzyUiHx2g"><img className="Log_thumbnail" src={Logo19} alt="Logo"/></a>
<h3 className="Log_text"><a href="https://www.youtube.com/watch?v=cNjzyUiHx2g">【VALORANT】ヘイブンのオーメン１キル確定ウルトがつよすぎたｗｗ【かおすぱれっと】</a>　<p>編集:永見こうき</p></h3>
</div>
<h4 className="Log_article">どうも！編集者の永見こうきです！今回ヴァロラントの動画を投稿するにあたって正直な感想、、、サムネづくりがいっちばんたのしい！！これからもヴァロラントの動画おたのしみに！！</h4>
</FadeIn.Up>
<FadeIn.Up>
<div className="Log_set">
<a href="https://youtu.be/O7xLhJfUX3Q"><img className="Log_thumbnail" src={Logo18} alt="Logo"/></a>
<h3 className="Log_text"><a href="https://youtu.be/O7xLhJfUX3Q">【minecraft】転生したらマイクラ世界のもう一つの地球だった件について『NewEarth』</a>　<p>編集:立花ケヱタ</p></h3>
</div>
<h4 className="Log_article">ついに投稿された一本目の動画。NewEarthといういわゆる“Earth系サーバー”と呼ばれる一つのワールドでわいわい建国していくシリーズ。今後かおすぱれっとの顔となっていくであろうマインクラフトシリーズであり、まだまだ撮影と編集に慣れていない雰囲気が垣間見える動画だなぁと感じる。ここからの成長に大きく期待すると同時にいつまでも大切な思い出として振り返ることになる特別な動画になったと思う。</h4>
</FadeIn.Up>
</div>
 );
}

    return(
     <div className='main'>
     <div className="header_button">
       <img onClick={()=>this.handleClickHome()} className="logo2" src={Logo2} alt="Logo2" />
       <button onClick={()=>this.handleClickAbout()} className="button1" name="" type="submit" value="About">About</button>
       <button onClick={()=>this.handleClickNews()} className="button2" type="submit" value="News">News</button>
       <button onClick={()=>this.handleClickMembers()}  className="button3" type="submit" value="Members">Members</button>
       <button onClick={()=>this.handleClickContact()} className="button4" type="submit" value="Contact">Contact</button>
       <button onClick={()=>this.handleClickLog()} className="button5" type="submit" value="Log">Log</button>
     </div>
     {Contents}
     {Char}
     </div>
    );
  }
}

export default Main;
